import { FirebaseError } from 'firebase/app';
import { doc, getDoc } from 'firebase/firestore';

import { db } from '../../config';

export const fetchDocumentById = async <T>(
  collectionPath: string,
  documentId: string,
): Promise<T | null> => {
  try {
    const documentRef = doc(db, collectionPath, documentId);
    const documentSnapshot = await getDoc(documentRef);

    if (!documentSnapshot.exists()) {
      throw new FirebaseError('not-found', `Document with ID ${documentId} not found`);
    }

    return { id: documentSnapshot.id, ...documentSnapshot.data() } as unknown as T;
  } catch (error) {
    throw new FirebaseError('unknown', `Failed to fetch document: ${(error as Error).message}`);
  }
};
